var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHomeActive = function SvgHomeActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.292 5.37h4.121a.255.255 0 0 1 .256.255v10.09h-4.65V5.624a.256.256 0 0 1 .273-.255Z",
    fill: "#E3D4C0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.697 13.274 14.726 2.304a1.039 1.039 0 0 0-1.468 0L2.295 13.273a1.039 1.039 0 0 0 .734 1.773h1.278v9.743a1.558 1.558 0 0 0 1.558 1.558h16.254a1.558 1.558 0 0 0 1.558-1.558v-9.743h1.286a1.039 1.039 0 0 0 .734-1.773Z",
    fill: "#D1B896"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.037 13.146 15.101 2.253a1.599 1.599 0 0 0-2.202 0L1.963 13.146a1.586 1.586 0 0 0 1.085 2.646 1.105 1.105 0 0 0 .797-.318l9.828-9.797a.471.471 0 0 1 .654 0l9.828 9.797a1.102 1.102 0 0 0 .797.318 1.6 1.6 0 0 0 1.374-.985 1.583 1.583 0 0 0-.289-1.66Z",
    fill: "#DAC6AB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 26.3h-8v-6.1a3.86 3.86 0 0 1 1.175-2.755A4.064 4.064 0 0 1 14 16.3a4.064 4.064 0 0 1 2.825 1.145A3.86 3.86 0 0 1 18 20.199v6.1Z",
    fill: "#A79378"
  })));
};
export default SvgHomeActive;